import { Controller } from '@hotwired/stimulus';

const DELAY = 5000;

export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.element.remove(), DELAY);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
